import { useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import TitleBar from '../../../components/TitleBar';
import { useParams } from 'react-router-dom';
import {
  ASSIGN_USER_TO_ROLES,
  GET_USER_BY_UUID,
  UNASSIGN_USER_FROM_ROLES,
  UPDATE_USER,
} from '../queries';
import { AntModal, Footer, Spinner } from '../../../components';
import { UserData } from './types';
import RolesAssigmentForm from './RolesAssigmentForm';
import { Field } from '../../../components/generic/Field';
import { getOrganization } from '../../../utils/config';

export const UserDetail = () => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [openEditModal, setopenEditModal] = useState(false);
  const uuid = getOrganization();
  const params = useParams();
  const [roleIds, setroleIds] = useState<string[]>();
  const [loadingRolesAssign, setloadingRolesAssign] = useState(false);
  const [loadingRolesUnAssign, setloadingRolesUnAssign] = useState(false);
  const [errorRoles, seterrorRoles] = useState<any>('');

  const fields: Field[] = [
    { label: 'Name', key: 'name' },
    { label: 'Nickname', key: 'nickname' },
  ];

  const updateGQL = useMutation(UPDATE_USER, {
    refetchQueries: ['GetUserByUuid'],
  });

  const { loading, error, data } = useQuery<UserData>(GET_USER_BY_UUID, {
    variables: { uuid: params.userId, organizationUuid: uuid },
  });

  const assignRoleMutation = useMutation(ASSIGN_USER_TO_ROLES, {
    refetchQueries: ['GetUserByUuid'],
  });

  const unassignRoleMutation = useMutation(UNASSIGN_USER_FROM_ROLES, {
    refetchQueries: ['GetUserByUuid'],
  });

  const handleRolesAssignment = async () => {
    await onRequest(
      assignRoleMutation[0],
      {
        variables: {
          roleIds: roleIds,
          userId: data?.getUserByUuid.uuid,
          organizationUuid: uuid,
        },
      },
      true,
    );
  };

  const handleRolesUnAssigment = async (roleId: any) => {
    await onRequest(unassignRoleMutation[0], {
      variables: {
        organizationUuid: uuid,
        roleIds: [roleId],
        userId: data?.getUserByUuid.uuid,
      },
    });
  };

  const onRequest: any = async (
    request: any,
    params: object,
    assign: boolean,
  ) => {
    if (assign) {
      setloadingRolesAssign(true);
    } else {
      setloadingRolesUnAssign(true);
    }

    try {
      await request(params);
      setmodalOpen(false);
    } catch (error) {
      seterrorRoles(error);
    } finally {
      if (assign) {
        setloadingRolesAssign(false);
      } else {
        setloadingRolesUnAssign(false);
      }
    }
  };

  if (loading || loadingRolesUnAssign) return <Spinner />;
  if (error) return <>Error! ${error.message}</>;

  const onChange = (value: string[]) => {
    setroleIds(value);
  };

  return (
    <>
      <TitleBar title="User Detail" />
      <section className="flex flex-col gap-4">
        <section className="flex justify-between">
          <section className="flex items-center gap-3">
            <img
              src={data?.getUserByUuid.picture}
              className=" w-20 h-20 rounded-full"
              alt="User Profile"
            />
            <h2>{data?.getUserByUuid.name}</h2>
          </section>
          {/* <Button
            type="default"
            className="h-8"
            onClick={() => setopenEditModal(true)}
          >
            Edit
          </Button> */}
        </section>
      </section>
      <AntModal
        openModal={modalOpen}
        onCancel={() => setmodalOpen(false)}
        title="ASSIGN ROLES"
      >
        <form className="w-full h-44">
          <RolesAssigmentForm
            waiting={loadingRolesAssign}
            onSubmit={handleRolesAssignment}
            onChange={onChange}
            alredyAssignedRoles={data?.getUserByUuid.roles!}
            errorRoles={errorRoles}
          />
        </form>
      </AntModal>
      <Footer backPath="/users-management" />
      {/* <Modal
        open={openEditModal}
        onClose={() => setopenEditModal(false)}
        title="User Edition"
      >
        <Form
          data={data?.getUserByUuid}
          fields={fields}
          updateGQL={updateGQL}
          showDelete={false}
          onCancel={() => {
            setopenEditModal(false);
          }}
        />
      </Modal> */}
    </>
  );
};
